import { useState, useRef } from 'react';
import './ECheckSlot.css';
import { toast } from 'react-toastify';
import { apiV1 } from '../../lib/axios';
import { getApiErrorMessage } from '../../utils/getApiErrorMessage';
import { echeckMiniGameImages } from './img/base64images';
import ReactInputMask from 'react-input-mask';

const images = echeckMiniGameImages;

const ECheckSlot = () => {
  const [showGame, setShowGame] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [currentImages, setCurrentImages] = useState([ images[0], images[0], images[0] ]);
  const [winner, setWinner] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    pix: '',
  });
  const [error, setError] = useState(null);

  const nameRef = useRef();
  const emailRef = useRef();
  const phoneRef = useRef();
  const pixRef = useRef();
  
  const startGame = async (e) => {
    setError(null);
    e.preventDefault();
    if(formLoading) return;
    setFormLoading(true);

    try{
      const name = nameRef.current.value.trim();
      const email = emailRef.current.value.trim();
      const phone = phoneRef.current.value.trim().replace(/\D/g, '');
      const pix = pixRef.current.value.trim();
  
      const isValidName = name.split(' ').length >= 2;
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      const isValidPhone = phone.length >= 10 && phone.length <= 11;
      const isValidPix = pix.length >= 5;
  
      if (!isValidName) return setError('Digite seu nome completo (nome e sobrenome).');
      if (!isValidEmail) return setError('Digite um e-mail válido.');
      if (!isValidPhone) return setError('Digite um número de WhatsApp válido com DDD.');
      if (!isValidPix) return setError('Digite uma chave PIX válida.');
      
      setFormData({ name, email, phone, pix });
  
      const isValidPixKey = await checkPixKey(pix);
      if (!isValidPixKey) return;
  
      setShowGame(true);
    } catch (error) {
      console.log("error ", error);
      setError('Ocorreu um erro ao iniciar o jogo. Por favor, tente novamente.');
    } finally {
      setFormLoading(false);
    }
  };

  const checkPixKey = async (pix) => {
    try{
      const response = await apiV1.get(`/echeque/niquel/check-pixkey/${pix}`);
      if (response.data.alreadyExists) {
        setError('Esta chave PIX ja foi utilizada. Por favor, utilize outra chave.');
        return false;
      }
    } catch (error) {
      setError('Chave Pix inválida.');
      return false;
    }

    return true;
  }

  const intervals = useRef([]);

  const createReelInterval = (reelIndex, delay) => {
    let i = 0;
    return setInterval(() => {
      setCurrentImages(prevImages => {
        const newImages = [...prevImages];
        newImages[reelIndex] = images[i % images.length];
        return newImages;
      });
      i++;
    }, delay);
  };

  const clearAllIntervals = () => {
    intervals.current.forEach(clearInterval);
    intervals.current = [];
  };

  const spin = () => {
    if (spinning || !images.length) return;

    if (winner) {
      toast.warning('Você já ganhou! Aguarde o próximo sorteio.');
      setShowGame(false);
      setWinner(false);
      setCurrentImages([images[0], images[0], images[0]]);
      clearAllIntervals();
      return;
    }

    setSpinning(true);

    intervals.current = [
      createReelInterval(0, 80),
      createReelInterval(1, 100),
      createReelInterval(2, 120),
    ];

    setTimeout(async () => {
      clearAllIntervals();

      const chosenImage = images[images.length - 1];
      setCurrentImages([chosenImage, chosenImage, chosenImage]);

      try{
        sendEcheck()
        setWinner(true);
      } catch (error) {
        toast.error(getApiErrorMessage(error, 'Erro ao enviar o e-Check'))
      } finally {
        setSpinning(false);
      }
    }, 2000);
  };

  const sendEcheck = async () => {
    await apiV1.post('/echeque/niquel/create', formData);
  }

  return (
    <div className="echeck-slot">
      {!showGame ? (
        <form onSubmit={startGame} className="form-echeck">
          <img src="/logo-echeck-branca.png" alt='logo echeck' />
          <h2>Gire a roleta e ganhe prêmios via e-Check!</h2>

          <input ref={nameRef} type="text" placeholder="Nome completo" required /><br />
          <input ref={emailRef} type="email" placeholder="E-mail" required /><br />
          <ReactInputMask mask="(99) 99999-9999" placeholder="WhatsApp" required>
            {(inputProps) => <input ref={phoneRef} type="tel" {...inputProps} />}
          </ReactInputMask><br />
          <input ref={pixRef} type="text" placeholder="Chave PIX para receber o prêmio" required /><br />

          {error && <div className="error">{error}</div>}

          <button type="submit">{formLoading ? "Carregando..." : "Começar"}</button>
        </form>
      ) : (
        <>
          <div className="d-flex align-items-center justify-content-evenly flex-column h-100">
            <img src="/logo-echeck-branca.png" alt='logo echeck' className="logo-echeck-mini-game" />
            <div className='mainContainer'>
              <div className="slot-machine">
                <div className="slotwrapper">
                  {[0, 1, 2].map((_, colIdx) => (
                    <ul key={colIdx}>
                      {[...Array(7)].map((_, i) => (
                        <li key={i}>
                          <img src={currentImages[colIdx]} alt={`Slot ${colIdx}-${i}`} />
                        </li>
                      ))}
                    </ul>
                  ))}
                </div>
                <img
                  src="https://i.ibb.co/MfSZ71p/7670530.png"
                  alt="Decorativo"
                  className="w-100"
                />
                <button
                  type="button"
                  className={`slot-machine-btn ${spinning ? 'clicked' : ''}`}
                  onClick={spin}
                >
                  <img
                    src="https://i.ibb.co/0VTc2LZ/spin-btn.png"
                    alt="Girar"
                    className="w-100"
                  />
                </button>
              </div>
            </div>
            <div className='d-flex flex-column align-items-center justify-content-center'>
              {winner && <div id="message"> 🎉Você acaba de ganhar R$0,05 via e-Check! </div>}
              {winner && <div id="message2"> Agora pra ganhar mais folego no seu fluxo de caixa <br/> comece hoje mesmo a utilizar o e-Check </div>}
              {winner && <div id="message3"> Verifique sua caixa de email.</div>}
              {(!spinning && !winner && showGame) && <div className="alert">Puxe a alavanca para girar!</div>}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ECheckSlot;
